'use client'

import { Button } from '@/components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { resolveSignInTarget } from '@/server/auth/actions'

import { useState, useTransition } from 'react'
import { useForm } from 'react-hook-form'

import { useRouter } from 'next/navigation'

import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({ email: z.email() })

export function EmailLookupForm({ redirectTo }: { redirectTo: string | null }) {
  const router = useRouter()
  const [error, setError] = useState('')
  const [pending, startTransition] = useTransition()
  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: { email: '' }
  })

  const onSubmit = ({ email }: { email: string }) => {
    setError('')
    startTransition(async () => {
      const result = await resolveSignInTarget({ email, redirectTo })
      if (result.url) {
        router.push(result.url)
      } else {
        setError('If your email exists, you will be redirected shortly.')
      }
    })
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-6"
      >
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="you@example.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        {error && <p className="text-sm text-red-500">{error}</p>}
        <Button type="submit" className="w-full" disabled={pending}>
          {pending ? 'Checking...' : 'Continue'}
        </Button>
      </form>
    </Form>
  )
}
